import { reportCubeCatalog } from './catalog.js';
const { tenant } = reportCubeCatalog;
const allTenantMembers = new Set(Object.values(tenant.memberByCube));
export const resolveTenantScoping = (cubeName) => ({
    tenantMember: tenant.memberByCube[cubeName],
    allTenantMembers,
});
